<template>
  <div class="block relative py-24 sm:pb-48 sm:pt-56" :class="{'w-full': inGrid}">
    <div class="container xxl:px-24" :class="{'pb-48': inGrid}">
      <div class="mx-auto text-center md:w-2/3">
        <span
          class="pt-48 quote-sign text-brown-75 font-normal leading-sm text-6xl block"
        >
          ”
        </span>
        <div v-if="component.rating > 0" class="pt-12 pb-12">
          <fa
            v-for="s in Array.from(Array(Math.floor(component.rating)))"
            :key="s"
            class="ml-6 mt-2 text-star-yellow"
            :icon="['fas', 'star']"
          />
          <fa
            v-if="component.rating - Math.floor(component.rating) >= 0.8 && score != Math.floor(component.rating)"
            class="text-star-yellow"
            :icon="['fas', 'star']"
          />
          <fa
            v-else-if="component.rating - Math.floor(component.rating) <= 0.2 && component.rating != Math.floor(component.rating)"
            class="text-star-yellow"
            :icon="['far', 'star']"
          />
          <fa
            v-else-if="component.rating != Math.floor(component.rating)"
            class="text-star-yellow"
            :icon="['fas', 'star-half-alt']"
          />
        </div>
        <h4 class="mb-16 text-brown-75 text-xl leading-lg">
          {{ component.quote }}
        </h4>
        <div class="text-sm text-black-75">
          <span v-if="component.author">
            {{ component.author }}
          </span><br>
          <span v-if="component.organization" class="italic text-brown-75">
            {{ component.organization }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    inGrid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>
<style>
.quote-sign {
  font-family: auto;
}
</style>
